export const Logo = ({ testId = "marketshipt-nav-logo", light = false, href = "#top" }) => (
  <a href={href} data-testid={testId} className="flex items-center gap-2.5 group">
    <span className="h-10 w-10 rounded-xl bg-white overflow-hidden ring-1 ring-slate-200 flex items-center justify-center transition-transform duration-300 group-hover:-rotate-6">
      <img src="/brand/logo.png" alt="Marketgetr logo" className="h-full w-full object-cover scale-[1.35]" />
    </span>
    <span className={`font-display text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-[#13296B]"}`}>
      Market<span className="text-[#2F7FF0]">getr</span>
    </span>
  </a>
);

export const Eyebrow = ({ children, light = false }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.25em] ${light ? "text-[#8FB8F7]" : "text-[#2F7FF0]"}`}>
    {children}
  </p>
);
